function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgEnvelope(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "envelope",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 59 67",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-1",
    points: "13.57 0 1.64 6.05 46.41 29.11 58.34 23.07 13.57 0",
    style: {
      fill: "#76d1ff"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-2",
    points: "46.41 29.11 46.41 66.49 58.34 60.44 58.34 23.07 46.41 29.11",
    style: {
      fill: "#0250c1"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-3",
    points: "1.64 43.7 46.41 66.5 46.41 29.11 1.64 6.05 1.64 43.7",
    style: {
      fill: "#4285f4"
    }
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group-6"
  }, /*#__PURE__*/React.createElement("polyline", {
    id: "Stroke-4",
    points: "1.01 8.53 21.32 43.35 24.66 45.5 33.78 39.53 46.47 31.22",
    style: {
      fill: "none",
      stroke: "#fff",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: 2
    }
  })), /*#__PURE__*/React.createElement("path", {
    id: "Fill-7",
    d: "M46.41,60.83,33.78,40.53Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group-10"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Stroke-8",
    d: "M46.47,59.93l-12.7-20.4",
    style: {
      fill: "none",
      stroke: "#fff",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: 2
    }
  })), /*#__PURE__*/React.createElement("path", {
    id: "Fill-11",
    d: "M1.67,39.58l12.63-7.24Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "Stroke-12",
    d: "M14.31,32.34,1.67,39.58",
    style: {
      fill: "none",
      stroke: "#fff",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: 2
    }
  }));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEnvelope);
export default __webpack_public_path__ + "static/media/envelope.157529af3ea3e2441c0e99203dba9b8a.svg";
export { ForwardRef as ReactComponent };